// extracted by mini-css-extract-plugin
var _1 = "TopicActivitiesPanel-module__content--fQ0Y0";
var _2 = "TopicActivitiesPanel-module__header--tTndW";
export { _1 as "content", _2 as "header" }
